function DeviceService($q, AppSettings, AuthService, CommonService) {
    'ngInject';
  
    const service = {};
  
    // 장비 목록
    service.myList = function (params) {
      const url = AppSettings.apiUrl.restRoot + 'device/my_list';
      return CommonService.post(url, params);
    };
  
    // 장비 생성/수정
    service.set = function (params) {
      const url = AppSettings.apiUrl.restRoot + 'device/set';
      return CommonService.post(url, params);
    };
  
    // 장비 삭제
    service.remove = function (params) {
      const url = AppSettings.apiUrl.restRoot + 'device/remove';
      return CommonService.post(url, params);
    };
  
    return service;
  }
  
  export default {
    name: 'DeviceService',
    fn: DeviceService
  };